import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { h } from "preact";
import { ApiBackedComponent } from "../../common/components/ApiBackedComponent";
import PieChart from "../../common/components/PieChart";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
} from "../../common/generic/generic-helper";
import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { NBIKpis } from "../../common/generic/generic-nbi-domains";
import {
  IFilterItem,
  IGenericRequest,
} from "../../common/generic/generic-types";
import {
  BuildPortfolioFilters,
  CreateDateFromFilter,
} from "../../common/portfolio/portfolio-filter";
import { IProps } from "../../common/portfolio/portfolio-types";
import { mapData } from "../utils/helper";

const kpis = "nbi_ytd";
const attributes = "fpv_sbl,fpv_ssbl";
const sortOrder = "fpv_sbl";

interface IState {
  data: any[];
  drillDownData: any[];
}
const kpi = new NBIKpis();
const attr = new NbiDimensions();
export class NbiYtdPerSblClass extends ApiBackedComponent<
  IProps & IWidgetConfigurationProps,
  IState
> {
  public constructor() {
    super();
    this.setState({
      data: [],
      drillDownData: [],
    });
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <PieChart
        data={this.state.data}
        drillDownData={this.state.drillDownData}
      />
    );
  }

  // tslint:disable-next-line:cognitive-complexity
  protected async fetchApiData(props: IProps) {
    this.initCorrelationId();
    const headers = props.headers;

    // make it work before change on metadata
    if (
      props.attribute === undefined ||
      props.attribute === null ||
      props.attribute === ""
    ) {
      props.attribute = attr.CLIENT_GEN_ID;
    }
    const filter = BuildPortfolioFilters(props.filters);
    const isClientMandatory = this.validateIsClientMandatory(props, filter);
    if (isClientMandatory) {
      this.setState({
        data: [],
        drillDownData: [],
      });
      this.setDataStatus("no-client");
      return;
    }
    this.setDataStatus("loading");

    const dateFilter = this.getDateFilter(props);

    const genericRequest: IGenericRequest = {
      aggregationAttributes: attributes,
      date: dateFilter,
      filter: GenericFilterBuilder(filter),
      kpis: kpis,
      sort: sortOrder,
    };
    const responseData = await MakeGenericApiCall(
      headers,
      "nbi",
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );
    const errorStatus = CheckReponseDataForError(responseData);
    if (errorStatus) {
      this.setDataStatus(errorStatus);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: [],
        drillDownData: [],
      });
    } else {
      const result = mapData(responseData);
      if (result.data.length !== 0) {
        this.setState({
          data: result.data,
          drillDownData: result.drillDownData,
        });
        this.setDataStatus("ready");
      } else {
        this.setState({
          data: [],
          drillDownData: [],
        });
        this.setDataStatus("no-data");
      }
    }
  }
  private getDateFilter(props: IProps) {
    return props.filters &&
      props.attribute &&
      attr.CLIENT_GEN_ID === props.attribute
      ? props.filters.value === undefined
        ? new Date().toISOString().slice(0, 10)
        : new Date(props.filters.value as string).toISOString().slice(0, 10)
      : CreateDateFromFilter(props.filters);
  }

  private validateIsClientMandatory(props: IProps, filter: IFilterItem[]) {
    return (
      props.attribute &&
      attr.CLIENT_GEN_ID === props.attribute &&
      filter.filter(x => x.attribute === attr.CLIENT_GEN_ID).length === 0
    );
  }
}

export const NbiYtdPerSbl = withWidgetConfiguration(NbiYtdPerSblClass);
